import React from 'react';
import BasicData from './tabs/basic-data/BasicData';
import Amenities from './tabs/amenities/Amenities';
import Images from './tabs/images/Images';
import PriceList from './tabs/price-list/PriceList';
import Other from './tabs/other/Other';

export const tabs = [
  {
    key: 'basicData',
    label: 'Dane podstawowe',
    withHeader: false,
    content: <BasicData />,
  },
  {
    key: 'priceList',
    label: 'Cennik',
    withHeader: false,
    content: <PriceList />,
  },
  {
    key: 'amenities',
    label: 'Udogodnienia',
    withHeader: false,
    content: <Amenities />,
  },

  {
    key: 'images',
    label: 'Zdjęcia',
    withHeader: false,
    content: <Images />,
  },

  {
    key: 'other',
    label: 'Inne',
    withHeader: false,
    content: <Other />,
  },
];
